import Chip from "@mui/material/Chip";
import classNames from "classnames";
import * as React from "react";

type ChipLabelProps = {
  label: string;
  isActive: boolean;
  hasUnreadOutput: boolean;
};

const ChipLabel = ({ label, isActive, hasUnreadOutput }: ChipLabelProps) => {
  return (
    <div className="relative">
      <Chip
        label={label}
        className={classNames("!bg-text-success-states-hover", {
          "!text-text-success-dark": isActive,
          "!text-text-disabled": !isActive,
        })}
      />
      {hasUnreadOutput && <div className="absolute top-0 right-0 h-2 w-2 rounded-full bg-primary-blue-main"></div>}
    </div>
  );
};

export default ChipLabel;
